import axios from 'axios'

const state = {
  users: null
}

const getters = {
  StateUsers: state => state.users,
}

const actions = {
  async CreateUser ({ dispatch }, user) {
    return axios
      .post('users', user)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetUsers')
      })
  },
  async GetUsers ({ commit }) {
    return axios
    .get('users')
      .then(response => {
        commit('setUsers', response.data)
        return response.data
      })
      .catch(error => { throw(error) })
      .finally(() => {
        //dispatch('GetDNSRecords', record.domain_id)
      })
    
  },
  async UpdateUser ({ dispatch }, user) {
    return axios
      .put('users/' + user.id, user)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetUsers')
      })
  },
  async DeleteUser ({ dispatch }, user) {
    return axios
      .delete('users/' + user.id)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetUsers')
      })
  }
}

const mutations = {
  setUsers (state, users) {
    state.users = users
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
